// extracted by mini-css-extract-plugin
export default {"privacy-container":"privacy_privacy-container__+2H6V"};